$(document).ready(function() {
	if(!document.querySelector('.C0009')) return false;

	var targetHash = document.location.hash;
	if(targetHash === '#bulkOrder'){
		document.getElementsByClassName("bulk-order-click-here")[0].click()
	}
	window.addEventListener('hashchange', function(){
		if(targetHash === '#bulkOrder'){
			document.getElementsByClassName("bulk-order-click-here")[0].click()
		}
	});
	
	var shopType;
	var $nav = $('.navigation');
	if ($nav.length) {
		shopType = $nav.data('store');
	} else {
		shopType = 'obs';
	}
	$('.C0009').attr('data-store', shopType);

	tinyLayer.initModule('.swatch, .flag-icon .flag-item'); //PJTWAUS-1 : 20200113 add
	var common = {
		breakpointMaxMd: mql.maxMd,
		breakpointMaxSm: mql.maxSm,
		p: null
	};

	var $snsArea = $('.pdp-summary-area .sns-area');
	$snsArea.find('.sns').on('click', function(e){
		e.preventDefault();
		var $snsLayer = $(this).closest('.sns-area').find('.list');
		var _this = $(this); /* PJTWAUS-1 : 20191210  add */
		if($snsLayer.hasClass('active')) {
			$snsLayer.removeClass('active');
		} else {
			$snsLayer.addClass('active');
			/* PJTWAUS-1 : 20191210 add */
			var focusObj = $snsLayer.find('a[href], area[href], input:not([disabled]), input:not([readonly]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]');
			var focusFirst = focusObj.first();
			var focusLast = focusObj.last();
			
			focusLast.on('keydown', function (e) {
				if ((e.which === 9 && !e.shiftKey)) {
					e.preventDefault();
					$snsLayer.removeClass('active');
					_this.focus();
				}
			});
			focusFirst.on('keydown', function (e) {
				if ((e.which === 9 && e.shiftKey)) {
					e.preventDefault();
					$snsLayer.removeClass('active');
					_this.focus();
				}
			});
			/*// PJTWAUS-1 : 20191210 add */
		}
	});
	/* 20191127 : LGEUS-12620 */ 
	if($('.C0017 .directFrom .img-thumb').length > 0){ 
		$('.C0017 .directFrom .img-thumb').append('<img src="'+$('.C0009 img#base_detail_target').attr('data-src')+'" alt="'+$('.C0009 img#base_detail_target').attr('alt')+'"/>'); 

	} 
	/* //20191127 : LGEUS-12620 */
	
	var modal = {
		ready: true,
		el: {
			gallery: document.getElementById('modal_pdp_detail_gallery')
		},
		is360VR : null,
		iframe: {
			target: null,
			code: null,
			get360viewCode: function(t){
				var url = t.getAttribute('data-href'),
					title = t.getAttribute('data-title');
				var iframe;

				iframe = '<iframe src="'+xssfilter(url)+'" title="'+xssfilter(title)+'"></iframe>';
				return iframe;
			}
		},
		slick: {
			el : {
				nav: null,
				visual: null
			},
			opt : {
				nav: {
					/* LGEUS-11794 : 20190813 modify */
					lazyLoad: 'progressive',
					infinite: false,
					listStyle: true, /* PJTWAUS-1 : 20200128 add */
					slidesToShow: 4, /* LGEUS-931 modify */
					slidesToScroll: 4,
					//asNavFor: '#modal_detail_target',
					dots: true,
					focusOnSelect: true,
					vertical: false,
					dotsClass: 'pdp-pagination',
					swipeToSlide : true,
					defaultFocus : true
					/* //LGEUS-11794 : 20190813 modify */
				},
				visual: {
					swipe: false,
					infinite: false,
					listStyle: true,  /* PJTWAUS-1 : 20200128 add */
					lazyLoad: 'progressive',
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					fade: true,
					asNavFor: '#modal_thumbnail_target',
					responsive: [
						{
							breakpoint: 768,
							settings: {
								swipe: true
							}
						}
					]
				}
			},
			setIdx: function(){
				var _this = modal,
					_slick = modal.slick,
					_idx = _this.el.gallery.getAttribute('data-current-idx');

				if(_idx && typeof Number(_idx) == 'number') {
					$(_slick.el.visual)
						.slick('slickGoTo', _idx).slick('slickSetOption', {speed:300});
					$(_slick.el.nav).slick('slickGoTo', _idx);
				}
			},
			resetZindex: function(){
				setTimeout(function(){
					$('.slider-nav').find('li').removeAttr('tabindex');
					if($('.slider-nav').find('li').prop('tabIndex') == '-1'){
						$('.slider-nav').find('li a').removeAttr('tabindex')
					}
				},1000);
			},
			init: function(e){
				//console.log(e.type);
				var _this = modal,
					_slick = modal.slick,
					init = _this.el.gallery.getAttribute('data-initialized');
				if(e.type == 'shown' && !init) {
					$(_slick.el.visual).on({
						init: function(){
							setTimeout(function(){
								$(_slick.el.visual).slick('slickSetOption', {speed:10});
								_slick.setIdx();
							}, 10);
						}
					});
					for( var key in _slick.el ) {
						var _curSlick = _slick.el[key];
						if(!$(_curSlick).is('.slick-initialized')){
							$(_curSlick).slick(_slick.opt[key]);
						}
					}
					_slick.filterBranch(common.breakpointMaxSm, [true]);
					_this.el.gallery.setAttribute('data-initialized', true);
				}else if(e.type == 'shown' && init){
					// setPosition inside modal Slicks
					setTimeout(function(){
						$(_slick.el.visual).slick('setPosition');
						$(_slick.el.nav).slick('setPosition');
					},10);

				}else if(e.type == 'show' && init) {
					_slick.setIdx();
				}
				_slick.resetZindex();
				_slick.addEvent();
			},
			filterBranch: function(e, firstCheck){
				var _this = modal,
					_slick = modal.slick;

				if(!firstCheck) {
					$(_this.el.gallery).modal('hide');
				}

				if (e.matches) { // mobile;
					if(!$(_slick.el.nav).is('.slick-initialized')){
						$(_slick.el.nav).slick(_slick.opt.nav);
					}
					$(_slick.el.nav).slick('slickFilter', ':not(.view)');
					$(_slick.el.visual).slick('slickFilter', ':not(.view)');

					var $navItem = $(_slick.el.nav).find('.item');
					var $visItem = $(_slick.el.visual).find('.item');

					for (var i = 0; i < $navItem.length; i++) {
						var idx = $navItem.eq(i).attr('data-slick-index');
						if(is360VR) {
							$navItem.eq(i).attr('data-slick-index', idx-1);
							$visItem.eq(i).attr('data-slick-index', idx-1);
						} else {
							$navItem.eq(i).attr('data-slick-index', idx);
							$visItem.eq(i).attr('data-slick-index', idx);
						}
					}
				} else {
					$(_slick.el.nav).slick('slickUnfilter').slick('unslick'); //.find('.item').attr('tabindex', 0); /* PJTWAUS-1 : 20200131 add */
					$(_slick.el.visual).slick('slickUnfilter');
				}
			},
			addEvent: function(){
				var _this = modal,
					_slick = modal.slick;
				/* LGEUS-11794 : 20190813 modify */
				$(_slick.el.nav).find(".slick-list .slick-slide").on("click", function(e) {
					e.preventDefault();
		            var idx = $(e.currentTarget).closest(".slick-slide").index();
					$(_slick.el.visual).slick('slickGoTo', idx).slick('slickSetOption', {speed:300});
					$(e.currentTarget).addClass('slick-current slick-active').siblings().removeClass('slick-current slick-active');
				});
				$(_slick.el.nav).find(".slick-list .slick-slide").on("keydown", function(e) {
					if((e.keyCode == 9)) {
						$('.slider-nav').find('li').removeAttr('tabindex');
						$('.slider-nav').find('li a').removeAttr('tabindex');
					}

				});
				/* //LGEUS-11794 : 20190813 modify */
				$(_slick.el.visual).off().on({
					init: function(event, slick){
						//console.log(slick.$slides);
						// setTimeout(function(){
							$(_slick.el.visual).trigger('beforeChange', [slick, 0, 0]);
							$(_slick.el.visual).trigger('afterChange', [slick, 0]);
						// },100);
					},
					afterChange: function(event, slick, currentSlide, accFlag, accThis){ /* PJTWAUS-1 : 20200120 modify */
						var $this;
						if(accFlag){
							$this = $(accThis);
						}else{							
							$this = slick.$slides.eq(currentSlide);
							slick.$slides.eq(currentSlide).find('a').focus();

							var idx = currentSlide;
							/* LGEUS-11794 : 20190813 modify */
							$(_this.el.gallery.querySelector(".thumbnail.slider-nav")).find(".slick-slide").removeClass('slick-current slick-active');
							$(_this.el.gallery.querySelector(".thumbnail.slider-nav")).find(".slick-slide").eq(currentSlide).addClass('slick-current slick-active');
							/* //LGEUS-11794 : 20190813 modify */
							$(_this.el.gallery.querySelector('.pdp-visual-pagination .current')).text(currentSlide + 1);		
						}
						
						// iframe item check;
						var _iframe;
						if(accFlag){
							_iframe = $this.siblings('.iframe-area')[0];
						}else{
							_iframe = $this.find('.iframe-area')[0];
						}
						/*// PJTWAUS-1 : 20200120 modify */
						
						if(_iframe){
							var i = $(_iframe).data(),
								html;
							if(i.type == '360') {
								html = modal.iframe.get360viewCode(_iframe);
								$(_iframe).html(html);
							}else if(i.type == 'youtube'){
								$(_iframe).html('<div id="videoPlayerCode"></div>');
								setTimeout(function() {
									var player = new YT.Player('videoPlayerCode', {
										height: '360',
										width: '640',
										videoId: _iframe.getAttribute('data-href').split('watch?v=')[1],
										host: 'https://www.youtube.com',
										events: {
											'onReady': onPlayerReady,
											'onStateChange': onPlayerStateChange
										}
									});

									function onPlayerReady(event) {
										event.target.playVideo();
									}
									function onPlayerStateChange(event) {
										if (event.data == YT.PlayerState.PLAYING) {
											console.log('adobe-video', video.getTitle('youtube', player), 'play');
											_satellite.track('video_track',{name:video.getTitle('youtube', player),event:'play'});
										}
										if (event.data == YT.PlayerState.PAUSED) {
											console.log('adobe-video', video.getTitle('youtube', player), 'pause');
											_satellite.track('video_track',{name:video.getTitle('youtube', player),event:'pause'});
										}
									}
									
									var videoStatus = [0, 0, 0, 0];
									videoInterval = setInterval(function() {
										// console.log(player.getVideoData().title);
										var a = player.getDuration();
										var c = player.getCurrentTime();
										var p = parseInt((c*100)/a);
										for(var i=1;i<=4;i++) {
											if(p>=(25*i) && videoStatus[i-1]==0) {
												videoStatus[i-1] = 1;
												console.log('adobe-video', video.getTitle('youtube', player), 'ratio_'+(25*i));
												_satellite.track('video_track',{name:video.getTitle('youtube', player), event:'ratio_'+(25*i)});
											}
										}
										if(p>=99 && videoStatus[3]==0) {
											videoStatus[3]=1;
											console.log('adobe-video', video.getTitle('youtube', player), 'ratio_'+(25*4));
											_satellite.track('video_track',{name:video.getTitle('youtube', player),event:'ratio_'+(25*4)});
										}
									}, 2000);
								
								}, 10);
							}else if(i.type == 'brightcove'){
								$(_iframe).html('<div id="videoPlayerCode"></div>');
								var myPlayer,
									playerHTML,
									playerData = {
										accountId: _iframe.getAttribute('data-account'),
										playerId: _iframe.getAttribute('data-player'),
										videoId: _iframe.getAttribute('data-video-id')
									};

								playerHTML = '<video-js id="brightCovePlayer" data-video-id="' +playerData.videoId +'"  data-account="' +playerData.accountId +'" data-player="' +playerData.playerId +'" data-embed="default" data-application-id autoplay class="video-js" controls></video-js>';
								setTimeout(function() {
									document.getElementById("videoPlayerCode").innerHTML = playerHTML;
									var s = document.createElement("script");
									s.src = "https://players.brightcove.net/" + playerData.accountId + "/" + playerData.playerId + "_default/index.min.js"; 
									document.body.appendChild(s);
									s.onload = callback;
									function callback() {
										if($('#brightCovePlayer').length>0) {
											myPlayer = bc(document.getElementById('brightCovePlayer'));
											myPlayer.on("loadedmetadata", function() {
												myPlayer.muted(false);
												myPlayer.play();
											});
											myPlayer.on("pause", function() {
												console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'pause');
												_satellite.track('video_track',{name:video.getTitle('brightcove', myPlayer),event:'pause'});
											});
											myPlayer.on("play", function() {
												console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'play');
												_satellite.track('video_track',{name:video.getTitle('brightcove', myPlayer),event:'play'});
											});
										}
									}
									var videoStatus = [0, 0, 0, 0];
									videoInterval = setInterval(function() {
										//console.log(myPlayer.mediainfo.name);
										if($('#brightCovePlayer').length>0) {
											var a = myPlayer.mediainfo.duration;
											var c = myPlayer.currentTime();
											var p = parseInt((c*100)/a);
											for(var i=1;i<=4;i++) {
												if(p>=(25*i) && videoStatus[i-1]==0) {
													videoStatus[i-1] = 1;
													console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'ratio_'+(25*i));
													_satellite.track('video_track',{name:video.getTitle('brightcove', myPlayer),event:'ratio_'+(25*i)});
												}
											}
											if(p>=99 && videoStatus[3]==0) {
												videoStatus[3]=1;
												console.log('adobe-video', video.getTitle('brightcove', myPlayer), 'ratio_'+(25*4));
												_satellite.track('video_track',{name:video.getTitle('brightcove', myPlayer),event:'ratio_'+(25*4)});
											}
										}
									}, 2000);
								}, 10);
							}
						}
					},
					beforeChange: function(event, slick, currentSlide, nextSlide){
						var $this = slick.$slides.eq(currentSlide),
							$next = slick.$slides.eq(nextSlide);

						var _thisIframe = $this.find('.iframe-area')[0];
						if(_thisIframe) {
							$(_thisIframe).html('');
						}

						var _iframe = $next.find('.iframe-area')[0];
						if(_iframe){
							$(_this.el.gallery).addClass('loaded-iframe');
						}else {
							$(_this.el.gallery).removeClass('loaded-iframe');
						}
					}
				});
				// Galleries Pop up modal
				$(_this.el.gallery).off('click.nav, keydown').on({
					'click.nav, keydown': function(e){
						if((e.type == 'keydown' && e.keyCode == 13) || e.type == 'click') {
							var idx = $(e.currentTarget).index();

							//console.log(e.type, idx);
							$(_slick.el.visual)
								.slick('slickGoTo', idx).slick('slickSetOption', {speed:300});
							$(e.currentTarget).addClass('slick-current slick-active').siblings().removeClass('slick-current slick-active');
							$(e.currentTarget).attr('aria-current' ,true).siblings().attr('aria-current' ,false);
		
							//DC-538 START
							var label = nvl_def(_dl.page_name.sku)
							var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
							if(!bu) bu = nvl_def(_dl.page_name.bu);

							var count = 0;
							if($('#base_desktop_target .view').length > 0){
								count++;
							}
							if($('#base_desktop_target .video').length > 0 || $('#base_mobile_target .video').length > 0){
								count++;
							}
							
							var action = 'thumbnail '+ (idx+1 - count);
							dataLayer.push({
								"event": "lgEvent" ,
								"category": "image gallery pop up",
								"action": action,
								"label": label ,
								"businessUnit": bu ,
								"componentID": "C0009"
							});
							//DC-538 END
						}
					}
				}, '#modal_thumbnail_target:not(.slick-initialized) .item');
				common.breakpointMaxSm.addListener(_slick.filterBranch);
				
				/* PJTWAUS-1 : 20200120 add */
				$(document).off('click').on('click', '.wa-video', function(){
				    var _this = $(this);
				    var _linkArea = _this.data('link-area');
				    if(_this.data('type') == 'youtube'){
				    	var _href = _this.data('href');
				    	if(_this.hasClass('acc-change-video')){
					        _this.addClass('change-video').removeClass('acc-change-video').attr('data-link-area', _linkArea.replace('_ad','')).attr('aria-label',_this.data('desc')).text(_this.data('desc'));
					        _href = _this.data('acc-href');
					    }else{
					        _this.addClass('acc-change-video').removeClass('change-video').attr('data-link-area', _linkArea).attr('aria-label',_this.data('acc-desc')).text(_this.data('acc-desc'));
					        _href = _this.data('href');
					    }				    
					    _this.siblings('.iframe-area').attr('data-href', _href).find('iframe').attr('src', _href);			
				    }else{
				    	var _videoId = _this.data('video-id');
					    if(_this.hasClass('acc-change-video')){
					        _this.addClass('change-video').removeClass('acc-change-video').attr('data-link-area', _linkArea.replace('_ad','')).attr('aria-label',_this.data('desc')).text(_this.data('desc'));
					        _videoId = _this.data('acc-video-id');
					    }else{
					        _this.addClass('acc-change-video').removeClass('change-video').attr('data-link-area', _linkArea).attr('aria-label',_this.data('acc-desc')).text(_this.data('acc-desc'));
					        _videoId = _this.data('video-id');
					    }				    
					    _this.siblings('.iframe-area').attr('data-video-id', _videoId).find('iframe').attr('src', _videoId);
					    
				    }
				    $(modal.slick.el.visual).trigger('afterChange', [null, null, true, this]);				    
				    	    
				});
				/*// PJTWAUS-1 : 20200120 add */
			}
		},
		zoom: {
			/* LGEUS-186 : 20200225 add */
			_opt : {
				mobile : {
					transition: true,
					cursor: 'inherit',
					disablePan: false,
					disableZoom: false,
					disableXAxis: false,
					disableYAxis: false,
					which: 1,
					increment: 0.2,
					linearZoom: false,
					panOnlyWhenZoomed: true,
					minScale: 1,
					maxScale: 2,
					rangeStep: 0.05,
					duration: 200,
					contain: false,
					onPan: function(){
						$(this).addClass('dragged');
					},
					onZoom: function(){
						var $n = $(this);
						var matrix = $n.panzoom("getMatrix");
						if(matrix[0] <= "1.1") {
							if(matrix[4] != 0 && matrix[5] != 0){
								$n.panzoom("reset");
							}
						}
					}
				},
				pc: {
					transition: true,
					cursor: 'inherit',
					disablePan: false,
					disableZoom: false,
					disableXAxis: false,
					disableYAxis: false,
					which: 1,
					increment: 0.2,
					linearZoom: false,
					panOnlyWhenZoomed: true,
					minScale: 1,
					maxScale: 2,
					rangeStep: 0.05,
					duration: 200,
					contain: false,
					onPan: function(){
						$(this).addClass('dragged');
					},
					onZoom: function(){
						var $n = $(this);
						var matrix = $n.panzoom("getMatrix");
						if(matrix[0] <= "1.1") {
							if(matrix[4] != 0 && matrix[5] != 0){
								$n.panzoom("reset");
							}
						}
					}
				}
			},
			/*// LGEUS-186 : 20200225 add */
			init: function(){
				var _this = modal;
				var _zoom = this;
				var zoomImg = _this.el.gallery.querySelectorAll('.zoom-area img');
				var _opt = {
					mobile : {
						transition: true,
						cursor: 'inherit',
						disablePan: false,
						disableZoom: false,
						disableXAxis: false,
						disableYAxis: false,
						which: 1,
						increment: 0.2,
						linearZoom: false,
						panOnlyWhenZoomed: true,
						minScale: 1,
						maxScale: 2,
						rangeStep: 0.05,
						duration: 200,
						contain: false,
						onPan: function(){
							$(this).addClass('dragged');
						},
						onZoom: function(){
							var $n = $(this);
							var matrix = $n.panzoom("getMatrix");
							if(matrix[0] <= "1.1") {
								if(matrix[4] != 0 && matrix[5] != 0){
									$n.panzoom("reset");
								}
							}
						}
					},
					pc: {
						transition: true,
						cursor: 'inherit',
						disablePan: false,
						disableZoom: false,
						disableXAxis: false,
						disableYAxis: false,
						which: 1,
						increment: 0.2,
						linearZoom: false,
						panOnlyWhenZoomed: true,
						minScale: 1,
						maxScale: 2,
						rangeStep: 0.05,
						duration: 200,
						contain: false,
						onPan: function(){
							$(this).addClass('dragged');
						},
						onZoom: function(){
							var $n = $(this);
							var matrix = $n.panzoom("getMatrix");
							if(matrix[0] <= "1.1") {
								if(matrix[4] != 0 && matrix[5] != 0){
									$n.panzoom("reset");
								}
							}
						}
					}
				};

				if(!_this.el.gallery.getAttribute('data-zoom-initialized')) {
					_this.el.gallery.setAttribute('data-zoom-initialized', true);
					for (var i = 0; i < zoomImg.length; i++) {
						var __this = zoomImg[i],
							opt;
						if($(__this).is('.pc')) {
							opt = _opt.pc;
						}else {
							opt = _opt.mobile;
						}
						$(__this).panzoom(opt);
					}
					
				}

				if(!_this.el.gallery.getAttribute('data-zoom-event')){
					_this.el.gallery.setAttribute('data-zoom-event', true);
					_zoom.addEvent();
				}
				
			},
			zoomin: function($target, opt, max){
				$target.panzoom("zoom", false, {
					increment: max ? opt.maxScale : opt.increment,
					animate: true
				});
				if(opt.maxScale == $target.panzoom("getMatrix")[0]){
					$target.parent('.zoom-area').addClass('zoomout');
				}else {
					$target.parent('.zoom-area').removeClass('zoomout');
				}
			},
			zoominpos: function(e,$target, opt, max){
				$target.panzoom("zoom", false, {
					increment: max ? opt.maxScale : opt.increment,
					animate: true,
					focal:e
				});
				if(opt.maxScale == $target.panzoom("getMatrix")[0]){
					$target.parent('.zoom-area').addClass('zoomout');
				}else {
					$target.parent('.zoom-area').removeClass('zoomout');
				}
			},
			zoomout: function($target, opt){
				if($target.panzoom("getMatrix")[0] <= (1+opt.increment)) {
					$target.panzoom("reset");
				}else {
					$target.panzoom("zoom", true, {
						increment: opt.increment,
						animate: true
					});
				}
				$target.parent('.zoom-area').removeClass('zoomout');
			},
			clickAction: function(e){
				var _this = modal,
					_zoom = _this.zoom,
					currentTarget = e.currentTarget ? e.currentTarget : e.target,
					$target = $(currentTarget),
					opt;

				/* LGEUS-186 : 20200225 add */
				if($target.is('.pc')) {
					$target.panzoom(_zoom._opt.pc);
				}else {
					$target.panzoom(_zoom._opt.mobile);
				}
				/*// LGEUS-186 : 20200225 add */
				opt = $target.panzoom("option");
				if($target.is('.mobile')||!$target.is('.dragged')) { /* LGEUS-187 : 20200311 modify */
					var $area = $target.parent('.zoom-area');
					if(!$area.is('.zoomout')) {
						if(e.type == 'doubletap') {
							_zoom.zoominpos(e,$target, opt, true); // maximum zoomin
						}else {
							_zoom.zoominpos(e,$target, opt);
						}
					}else {
						$target.panzoom('reset');
						$area.removeClass('zoomout');
					}
				}

				$target.removeClass('dragged');
			},
			addEvent: function(){
				var _this = modal,
					_zoom = this;
				$(_this.el.gallery).on({
					'click.panzoom': function(e){
						var $target = $(_this.el.gallery).find('.slick-active .zoom-area img');
						var opt;
						var $btn = $(e.currentTarget);

						if(common.breakpointMaxSm.matches) {
							$target = $target.filter('.mobile');
						}else {
							$target = $target.filter('.pc');
						}
						/* LGEUS-186 : 20200225 add */
						if($target.is('.pc')) {
							$target.panzoom(_zoom._opt.pc);
						}else {
							$target.panzoom(_zoom._opt.mobile);
						}
						/*// LGEUS-186 : 20200225 add */

						opt = $target.panzoom("option");

						if($btn.is('.plus')){
							_zoom.zoomin($target, opt);
						}else if($btn.is('.minus')){
							_zoom.zoomout($target, opt);
						}
					}
				}, '.control button');

				if ('ontouchstart' in window){
					/* LGEUS-186 : 20200225 modify */
					setTimeout(function(){
						// in touch device
						var $target = $(_this.el.gallery).find('.zoom-area img');
						if(common.breakpointMaxSm.matches) {
							$target = $target.filter('.mobile');
						}else {
							$target = $target.filter('.pc');
						}
						for (var i = 0; i < $target.length; i++) {
							var _target = $target.eq(i)[0];
							var hammer = new Hammer(_target).on('doubletap', _zoom.clickAction);
							/*
							hammer.on('pinch pinchend', function(e) {
								_target.panzoom("setMatrix", '1, 0, 0, 1, 0, 0');
								alert('1, 0, 0, 1, 0, 0');
							});
							*/
						}						
					}, 2000);
					/*// LGEUS-186 : 20200225 modify */
				}else {
					$(_this.el.gallery).on({
						click: _zoom.clickAction,
						wheel: function(e){
							/*var $target = $(e.currentTarget);
							var opt = $target.panzoom("option");
							if(e.originalEvent.deltaY < 0) {
								_zoom.zoomin($target, opt);
							}else {
								_zoom.zoomout($target, opt);
							}*/
							/* LGEUS-12706 : 20200108 modify */
							e.preventDefault();
							var $target = $(e.currentTarget);
					            var delta = e.delta || e.originalEvent.wheelDelta;
					            var zoomOut = delta ? delta < 0 : e.originalEvent.deltaY > 0;
					            $target.panzoom('zoom', zoomOut, {
					              increment: 0.1,
					              focal: e
				            });
					        /* //LGEUS-12706 : 20200108 modify */
						}
					}, '.zoom-area img');
				}
			}
		},
		init: function(){
			var _this = this,
				_slick = _this.slick;

			if($('#base_desktop_target ul li.view.iframe').length>0) is360VR = true;
			else is360VR = false;

			_slick.el.nav = _this.el.gallery.querySelector('#modal_thumbnail_target');
			_slick.el.visual = _this.el.gallery.querySelector('#modal_detail_target');

			_this.addEvent();
		},
		showDetailModal: function(idx, _target){
			var _this = this;
			_this.el.gallery.setAttribute('data-current-idx', idx);
			if($(modal.slick.el.visual).is('.slick-initialized')) {
				$(modal.slick.el.visual).trigger('afterChange', [$(modal.slick.el.visual).slick('getSlick'), idx]);
			}
			$(modal.slick.el.nav).find('.item').eq(idx).addClass('slick-active slick-current').siblings().removeClass('slick-active slick-current');

			$(modal.slick.el.nav).find('img').each(function() {
				$(this).attr('data-src', $(this).attr('data-lazy')).addClass('lazyload').removeAttr('data-lazy');
			});

			//DC-538 START
			var label = nvl_def(_dl.page_name.sku)
			var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
			if(!bu) bu = nvl_def(_dl.page_name.bu);

			var count = 0;
			if($('#base_desktop_target .view').length > 0){
				count++;
			}
			if($('#base_desktop_target .video').length > 0 || $('#base_mobile_target .video').length > 0){
				count++;
			}

			dataLayer.push({
				"event": "lgEvent" ,
				"category": "pdp image",
				"action": "image " + (parseInt(idx) + 1 - count),
				"label": label ,
				"businessUnit": bu ,
				"componentID": "C0009"
			});
			//DC-538 END

			/* PJTWAUS-1 : 20200119 modify */
			if(_target != undefined){
				$(_this.el.gallery).modal({target: _target});
			}else{
				$(_this.el.gallery).modal({target: 'show'});
			}
			/*// PJTWAUS-1 : 20200119 modify */
			_this.zoom.init();
		},
		addEvent: function(){
			var _this = this,
				_slick = _this.slick;
			$(_this.el.gallery).on({
				'shown.bs.modal': _slick.init,
				'show.bs.modal': _slick.init,
				'hidden.bs.modal': function(){
					$(this).find('iframe').remove();
				}
			});
		}
	};

	var summaryGallery = {
		breakpoint: mql.maxMd, // ~ 991
		d: {
			el: document.getElementById('desktop_summary_gallery'),
			els: {
				nav: null,
				visual: null
			},
			init: function(){
				var _d = this;
				_d.els.visual = _d.el.querySelector('.pdp-visual-image');
				_d.els.nav = _d.el.querySelector('.pdp-thumbnail-nav');

				_d.setThumbnailsIdx();
				_d.addEvent();
				_d.el.setAttribute('data-initialized', true);
			},
			setThumbnailsIdx: function(){
				var _d = this;
				if(!_d.els.nav) _d.init();

				var lis = _d.els.nav.querySelectorAll('ul li');
				for (var i = 0; i < lis.length; i++) {
					var _li = lis[i];
					_li.setAttribute('data-idx', i);
				}

				var defaultIdx = $(_d.els.nav.querySelector('ul .thumbnail')).index();
				_d.els.visual.querySelector('img').setAttribute('data-idx', defaultIdx);
			},
			setImage: function(e){
				var _d = this,
					_img = _d.els.visual.querySelector('img'),
					/* 20190917 : LGEUS-12203 add */
					img = e.target.tagName == 'IMG'?e.target:e.target.children[0],
					/* //20190917 : LGEUS-12203 add */
					anchor = e.currentTarget,
					del = $(anchor).closest('li')[0],
					src = img.getAttribute('data-medium'),
					alt = img.getAttribute('data-large-alt') ? img.getAttribute('data-large-alt') : img.getAttribute('alt');

				_img.setAttribute('data-idx', del.getAttribute('data-idx'));
				_img.setAttribute('src', src);
				_img.setAttribute('alt', alt);

				$(del).addClass('active')
					.siblings().removeClass('active');
			},
			addEvent: function(){
				var _d = this;
				$(_d.els.nav).on({
					click: function(e){
						e.preventDefault();
						var del = $(this).closest('li')[0];
						//DC-538 START
						var label = nvl_def(_dl.page_name.sku)
						var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
						if(!bu) bu = nvl_def(_dl.page_name.bu);
						var action = "image gallery open";
						//DC-538 END
						if($(del).is('.thumbnail') && !$(del).is('.more')){ // thumbnail button
							var len = $(this).parent().siblings().length;
							var idx = parseInt(del.getAttribute('data-idx'));
							if (len > 3){
								var thumblen = $(this).parent().siblings('.thumbnail').length;
								var diff = len - thumblen;
								idx = idx - diff;
							}
							action = 'thumbnail '+ (idx+1);
							_d.setImage(e);
						}else if($(del).is('.more') || $(del).is('.iframe')){ 
							if($(del).is('.iframe')){
								action = "thumbnail 360"; //DC-538
							}
							var idx = del.getAttribute('data-idx');
							modal.showDetailModal(idx ? idx : 0, $(this)); /* PJTWAUS-1 : 20200119 modify */
						}
						//DC-538 START
						dataLayer.push({
							"event": "lgEvent" ,
							"category": "image gallery thumbnails",
							"action": action,
							"label": label ,
							"businessUnit": bu ,
							"componentID": "C0009"
						});
						//DC-538 END
					}
				}, 'a');
				if($(_d.els.nav).find('ul li').length>0) {
					$(_d.els.visual).on({
						click: function(e){
							var idx = e.target.getAttribute('data-idx');
							modal.showDetailModal(idx ? idx : 0, $(this)); /* PJTWAUS-1 : 20200119 modify */
						}
					}, 'a');
				}
			}
		},
		m: {
			el: document.getElementById('mobile_summary_gallery'),
			slick: {
				el: null,
				page: null,
				opt: {
					infinite:false, /* PJTWAUS-1 : 20200128 modify */
					listStyle: true,  /* PJTWAUS-1 : 20200128 add */
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows : true,
					dots: false,
					prevArrow: carouselOptions.bigAnglePrev, // common.js variable
					nextArrow: carouselOptions.bigAngleNext, // common.js variable
					responsive: [
						{
							breakpoint: 768,
							settings: {
								arrows: true
							}
						}
					],
				}
			},
			init: function(){
				var _m = this;
				_m.slick.el = _m.el.querySelector('.pdp-carousel');
				_m.slick.page = _m.el.querySelector('.pdp-visual-pagination');

				_m.setThumbnailsIdx();

				if(_m.slick.el.querySelectorAll('.default').length > 0) {
					// pagination max setting
					$(_m.slick.page.querySelector('.current')).text(1);
					$(_m.slick.page.querySelector('.length')).text(_m.slick.el.querySelectorAll('.default').length);

					$(_m.slick.el).slick(_m.slick.opt);

					_m.addEvent();
				}
				_m.el.setAttribute('data-initialized', true);
			},
			setThumbnailsIdx: function(){
				var _m = this;
				var lis = _m.slick.el.querySelectorAll('.default');
				for (var i = 0; i < lis.length; i++) {
					var _li = lis[i];
					_li.setAttribute('data-idx', i);
				}
			},
			addEvent: function(){
				var _m = this;
				
				$(_m.slick.el).on({
					beforeChange: function(event, slick, currentSlide, nextSlide){
						modal.ready = false;
					},
					afterChange: function(event, slick, currentSlide){
						modal.ready = true;
						slick.$slides.eq(currentSlide).find('a').focus();

						var idx = currentSlide;
						$(_m.slick.page.querySelector('.current')).text(currentSlide+1);
					}
				});

				$(_m.slick.el.querySelectorAll('.default')).on({
					click: function(e){
						var _del = e.delegateTarget,
						idx = e.delegateTarget.getAttribute('data-slick-index');/* LGEUS-187 : 20200311 modify */
						if(modal.ready == true) {
							modal.showDetailModal(idx ? idx : 0, $(this)); /* PJTWAUS-1 : 20200119 modify */
						}
					}
				}, 'a');
			}
		},
		init: function(){
			var _this = this;

			_this.addEvent();
			_this.mediaBranch(common.breakpointMaxMd);
		},
		mediaBranch: function(e, rebuild) {
			var _this = summaryGallery;

			if (e.matches) { // mobile;
				_this = _this.m;
			} else { 
				_this = _this.d;
			}

			if(_this.el.getAttribute('data-initialized') != 'true') {
				_this.init();
			}
		},
		addEvent: function(){
			var _this = this;
			common.breakpointMaxMd.addListener(_this.mediaBranch);
		}
	};

	// right pdp Summary 
	var detach = {
		id: null,
		els: {}
	};
	var info = {
		// group: typeof groupModelInfo != 'undefined'?groupModelInfo:null,
		// price: typeof priceModelInfo != 'undefined'?priceModelInfo:null
		group: null,
		price: null
	};
	var summary = {
		el: document.querySelector('.pdp-summary-area'),
		forms: document.querySelectorAll('.search-common'),
		els: {
			modal: {
				thumbnails: {
					target: document.getElementById('modal_thumbnail_target'),
					template: $('#modal_thumbnail_template').clone(),
				},
				detail: {
					target: document.getElementById('modal_detail_target'),
					template: $('#modal_detail_template').clone(),
				}
			},
			base: {
				mobile: {
					target: document.getElementById('base_mobile_target'),
					template: $('#base_mobile_template').clone(),
				},// thumbnail
				desktop: {
					target: document.getElementById('base_desktop_target'),
					template: $('#base_desktop_template').clone(),
				},
				detail: {
					target: document.getElementById('base_detail_target'),
				}
			}
		},
		create: {
			temp: null,
			desktopThumbnail: function(imgList){
				var _this = summary,
					_els = _this.els,
					// template = $(_els.base.desktop.template).clone().html(),
					// $desktopThumbnail = $(_els.base.desktop.target).find('.thumbnail img');
					$desktopThumbnail = $(_els.base.desktop.target).find('li:not(.view)'),
					length = 6,
					current, template,
					html = [];

					if(_this.create.temp == null) {
						_this.create.temp = $(_els.base.desktop.template).clone().html();
						$(_els.base.desktop.template).remove();
					}
					template = _this.create.temp;
					

					$desktopThumbnail.remove();

				for (var i = 0; i < length; i++) {
					var curData = imgList[i];
					// if(i < $desktopThumbnail.length) {
					// 	var $current = $desktopThumbnail.eq(i);
					// 	$current[0].setAttribute('src', curData.smallImageAddr);
					// 	$current[0].setAttribute('data-medium', curData.largeImageAddr);
					// 	$current[0].setAttribute('alt', curData.alt);

					// 	if(i == $desktopThumbnail.length-1) {
					// 		var moreLength = imgList.length - $desktopThumbnail.length;
					// 		$current.siblings('.count').text("+"+moreLength);
					// 	}
					// }

					try {
						if(curData.videoId){
							current = $(template).filter('.video').clone()[0];
							current.querySelector('img').setAttribute('src', curData.thumbnailImage);
							current.querySelector('img').setAttribute('alt', curData.videoDesc);
						}else if(i == (length-1)) {
							current = $(template).filter('.more').clone()[0];
							current.querySelector('img').setAttribute('src', curData.smallImageAddr);
							current.querySelector('img').setAttribute('data-medium', curData.largeImageAddr);
							var moreLength = imgList.length - length;
								$(current.querySelector('.count')).text("+"+moreLength);
						}else {
							current = $(template).filter('.thumbnail:not(.more)').clone()[0];
							current.querySelector('img').setAttribute('src', curData.smallImageAddr);
							current.querySelector('img').setAttribute('data-medium', curData.largeImageAddr);
						}
					} catch (e) {
							
					}
					current.setAttribute('data-idx', i+1);
					current.setAttribute('data-link-name', common.p.modelName);
					html[i] = current;
				}
				$(_els.base.desktop.target.querySelector('ul')).append(html);
			},
			elements: function(imgList, el, key){
				var _this = summary;
				var template = $(el.template).html(),
					html = [];

				for (var i = 0; i < imgList.length; i++) {
					var curData = imgList[i],
						condition = false,
						current, img;

					if(curData.videoId) {
						if($(template).filter('.video').length > 1) {
							// is zoom (detaill) image
							current = $(template).filter('.'+curData.videoType).clone()[0];
							if(curData.videoType == 'youtube') {
								current.querySelector('.iframe-area').setAttribute('data-href', 'https://www.youtube.com/watch?v='+curData.videoId);
							}else {
								current.querySelector('.iframe-area').setAttribute('data-video-id', curData.videoId);
							}
							current.querySelector('.iframe-area').setAttribute('data-title', curData.videoDesc);
							current.querySelector('.iframe-area').setAttribute('data-type', curData.videoType);
						}else {
							// thumbnail (nav)
							current = $(template).filter('.video').clone()[0];
							img = current.querySelector('img');
							img.setAttribute('src', curData.thumbnailImage);
							img.setAttribute('alt', curData.videoDesc);
						}
						condition = true;
					}else {
						current = $(template).filter('.image').clone()[0];
					}

					if(!condition) { // is not video contents
						img = current.querySelectorAll('img');
						if(img.length > 1) {
							// is zoom image
							$(img).filter('.pc')[0].setAttribute('data-lazy', curData.zoomImageAddr);
							$(img).filter('.mobile')[0].setAttribute('data-lazy', curData.zoomMobImageAddr);
						}else {
							// is thumbnail image
							img = img[0];
							if(key) {
								img.setAttribute('src', curData[key]);
							}else {
								img.setAttribute('src', curData.smallImageAddr);
							}
						}
						$(img).attr('alt', curData.imageAltText);
					}
					// 	current = $(template).clone()[0],
					
					html[i] = current;
				}

				return html;
			}
		},
		init: function(){
			var _this = this;
			_this.addEvent();

			var href = location.search ? location.search : location.hash,
				param = href.indexOf('=') > -1 ? href.split('=')[1] : href;
			param = param.indexOf('#') > -1 ? param.split('#')[0] : param;
			if(param) {
				$('a[data-sub-model-id="'+param+'"]').eq(0).trigger('click');
			}
			$('#modal_thumbnail_template, #modal_detail_template, #base_mobile_template, #base_desktop_template').remove();
		},
		changeSubModelInfo: function(id, subid){
			var _this = this,
				url = _this.el.getAttribute('data-sibling-url'),
				templateUrl = _this.el.getAttribute('data-template-url'),
				param = {
					modelId: id,
					subModelId: subid
				};
			var originalModelId = $('.C0009').attr('data-product-id');

			ajax.call(url, param, 'json', function(data){
				if(data.status == 'success' && data.data){
					var p = data.data[0];
					common.p = p;
					ajax.call(templateUrl, {}, 'html', function(html){
						if(html) {
							var pdpUrl = location.href;
							// simple data
							html = html
								.replace(/\*pdpUrl\*/g, pdpUrl)
								.replace(/\*userFriendlyName\*/g, p.userFriendlyName)
								.replace(/\*mediumImageAddr\*/g, p.mediumImageAddr)
								.replace(/\*productTag1\*/g, p.productTag1)
								.replace(/\*productTag2\*/g, p.productTag2)
								.replace(/\*modelName\*/g, p.modelName)
								.replace(/\*salesModelCode\*/g, p.salesModelCode)
								.replace(/\*modelId\*/g, p.modelId)
								.replace(/\*inquiryToBuyUrl\*/g, p.inquiryToBuyUrl)
								.replace(/\*findTheDealerUrl\*/g, p.findTheDealerUrl)
								.replace(/\*deliveryMessage\*/g, p.deliveryMessage)
								.replace(/\*installMessage\*/g, p.installMessage)
								.replace(/\*warrantyMessage\*/g, p.warrantyMessage)
								.replace(/\*defaultMessage\*/g, p.defaultMessage)
								// compatible
								.replace(/\*compatibleCount\*/g, p.compatibleCount)
								.replace(/\*compatibleModelsValidateUrl\*/g, p.compatibleModelsValidateUrl)
								.replace(/\*compatibleModelsPredictiveUrl\*/g, p.compatibleModelsPredictiveUrl)
								// price
								.replace(/\*rPrice\*/g, p.rPrice ? p.rPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
								// .replace(/\*msrp\*/g, p.msrp ? p.msrp.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
								.replace(/\*rPromoPrice\*/g, p.rPromoPrice ? p.rPromoPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
								.replace(/\*rPriceCent\*/g, p.rPriceCent)
								.replace(/\*rPromoPriceCent\*/g, p.rPromoPriceCent)
								.replace(/\*discountedRate\*/g, p.discountedRate)
								/* LGEUS-12083 : 20190826 modify */
								.replace(/\*rDiscountedPrice\*/g, p.rDiscountedPrice ? p.rDiscountedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 'null')
								.replace(/\*rDiscountedPriceCent\*/g, p.rDiscountedPriceCent)
								/* //LGEUS-12083 : 20190826 modify */
								.replace(/\*promotionText\*/g, p.promotionText)
								.replace(/\*retailerPricingText\*/g, p.retailerPricingText);
								
							/* LGEUS-106 : 20200224 add */
							if (p.wtbExternalLinkUseFlag=='Y') {
								html = html.replace(/\*whereToBuyUrl\*/g, p.wtbExternalLinkUrl)
										   .replace(/\*whereToBuyTarget\*/g, p.wtbExternalLinkSelfFlag=='N' ? "_blank" : "_self")
										   .replace(/\*whereToBuyTitle\*/g, p.wtbExternalLinkSelfFlag=='N' ? $(html).find('a.where-to-buy').attr('data-link-text') : "")
										   .replace(/\*whereToBuyName\*/g, p.wtbExternalLinkName);
							} else {
								html = html.replace(/\*whereToBuyUrl\*/g, p.whereToBuyUrl)
										   .replace(/\*whereToBuyTarget\*/g, "_self")
										   .replace(/\*whereToBuyTitle\*/g, "")
										   .replace(/\*whereToBuyName\*/g, $(html).find('a.where-to-buy').attr('data-link-text'));
							}
							/*//LGEUS-106 : 20200224 add */
							
							var $html = $(html),
								$keyBlocks = $html.find('*[data-key]'),
								$loopBlocks = $html.find('*[data-loop]');
							
							for (var i = 0; i < $keyBlocks.length; i++) {
								var $currentKeyBlock = $keyBlocks.eq(i),
									key = $currentKeyBlock.get(0).getAttribute('data-key'),
									val = p[key];
								/* LGEUS-106 : 20200224 add */
								if (p.wtbExternalLinkUseFlag=='Y' && key=='whereToBuyFlag') { 
									key = 'wtbExternalLinkUseFlag';
									val = p[key];
								}
								/*//LGEUS-106 : 20200224 add */
								if(!val || val == "N") {
									// discontinued
									if(key=="productTag1" && p.modelStatusCode=='DISCONTINUED' && $('.C0009').attr('data-flag-discontinued')) {
										$html.find('.flag span').html($('.C0009').attr('data-flag-discontinued'));
									} else {
										$currentKeyBlock.remove();
									}
								}
							}

							if(p.bizType.toUpperCase() == "B2B") {
								$html.find('.rating-area').remove();
							} else if(p.siblings[0].target && p.siblings[0].target.toUpperCase() == "SELF") {
								// If target is self, do not change the bv area
								$html.find('.rating-area').replaceWith('<div class="rating-area"><div data-bv-show="rating_summary" data-bv-product-id="'+originalModelId+'"></div></div>');
							}

							// change 360vr iframe url
							if(p.model360Image && p.model360Image != null) {
								$(_this.els.modal.detail.target).find('.iframe-area[data-type="360"]').attr('data-href', p.model360Image);
								$(_this.els.base.desktop.target).find('.view.iframe').show();
								$(_this.els.modal.thumbnails.target).find('.item.view').show();
							}else {
								$(_this.els.base.desktop.target).find('.view.iframe').hide();
								$(_this.els.modal.thumbnails.target).find('.item.view').hide();
							}

							// price setting
							var $prices = $html.find('.price-area');
							for (var i2 = 0; i2 < $prices.length; i2++) {
								var $this = $prices.eq(i2),
									$price;
								if(p.modelStatusCode=='DISCONTINUED') {
									$price = $this.find('.rPrice').clone();
									$price.html('');
									// DC-680 20210526 modify
								}else if(p.obsCondition == "Y") {
									if(p.rPrice && p.rPrice != null) {
										if(p.promoPriceUseFlag == "Y" && p.rPromoPrice != null) {
											$price = $this.find('.rPromoPrice').clone();
										}else if(p.bizType.toUpperCase() =='B2B' && p.msrpUseFlag=='Y') {
											$price = $this.find('.msrp').clone();
										}else {
											$price = $this.find('.rPrice').clone();
										}
									} else {
										$price = $this.find('.rPrice').clone();
										$price.html('');
									}
								} else {
									if(p.retailerPricingFlag=="Y") {
										$price = $this.find('.retailer').clone();
									} else {
										if(p.rPrice && p.rPrice != null) {
											if(p.promoPriceUseFlag == "Y" && p.rPromoPrice != null) {
												$price = $this.find('.rPromoPrice').clone();
											}else if(p.bizType.toUpperCase() =='B2B' && p.msrpUseFlag=='Y') {
												$price = $this.find('.msrp').clone();
											}else {
												$price = $this.find('.rPrice').clone();
											}
										} else {
											$price = $this.find('.rPrice').clone();
											$price.html('');
										}
									}
									// DC-680 20210526 modify
								}
								$this.html($price.html());
							}
 
							// compatibleCount type setting
							if(!p.compatibleCount && p.compatibleCount == 0){
								// compatible is empty
								$html.find('.compatible-area').remove();
							}else if(p.compatibleCount > 6) {
								// search type
								$html.find('.compatible-list').remove();
							}else if(p.compatibleCount <= 6) {
								// list type
								$html.find('.search-model').remove();
							}

							// loop contents setting
							for (var i3 = 0; i3 < $loopBlocks.length; i3++) {
								var $currentLoopBlock = $loopBlocks.eq(i3),
									_key = $currentLoopBlock.get(0).getAttribute('data-loop'),
									_val = p[_key];

								if(_key == 'siblings') {
									for (var j1 = 0; j1 < _val.length; j1++) {
										var siblingGroup = _val[j1],
											siblingTemplate, itemTemplate,
											type = siblingGroup.siblingType.toUpperCase(),
											selectCase = ["CARRIER", "CAPACITY", "COOLING CAPACITY"],
											ifSelectCase = selectCase.indexOf(type) > -1,
											siblingHtml = [],
											itemHtml = [],
											currentColor = '';

										if(type == "COLOR") {
											siblingTemplate = $currentLoopBlock.find('.template-sibling-color').clone().html();
										}else if(ifSelectCase){
											siblingTemplate = $currentLoopBlock.find('.template-sibling-option').clone().html();
											siblingTemplate = siblingTemplate.replace(/\*siblingType\*/g, type.toLowerCase());
										}else {
											siblingTemplate = $currentLoopBlock.find('.template-sibling-size').clone().html();
										}

										if(siblingGroup.target.toUpperCase() == "NEW"){
											itemTemplate = $(siblingTemplate).find('.new').clone().html();
										}else {
											itemTemplate = $(siblingTemplate).find('.self').clone().html();
										}

										for (var k = 0; k < siblingGroup.siblingModels.length; k++) {
											var model = siblingGroup.siblingModels[k];
											itemHtml = itemTemplate;
											itemHtml = itemHtml.replace(/\*subModelId\*/g, model.modelId)
															.replace(/\*siblingValue\*/g, model.siblingValue)
															.replace(/\*siblingType\*/g, model.siblingType.toLowerCase())
															.replace(/\*subModelUrl\*/g, model.modelUrl)
															.replace(/\*siblingCode\*/g, model.siblingCode);
											itemHtml = $(itemHtml).attr('aria-checked', false)[0].outerHTML; /* PJTWAUS-1 : 20200120 add */
											if(p.modelId == model.modelId) {
												if(ifSelectCase) {
													itemHtml = $(itemHtml).attr('selected', 'selected')[0].outerHTML;
												}else {
													itemHtml = $(itemHtml).addClass('active')[0].outerHTML;
													itemHtml = $(itemHtml).attr('aria-checked', true)[0].outerHTML;  /* PJTWAUS-1 : 20200120 add */
													if(type == "COLOR") {
														currentColor = model.siblingValue;
													}
												}
											}
											siblingHtml += itemHtml;
										}

										var $temp = $(siblingTemplate);
										$temp.find(ifSelectCase ? 'select' : 'div').html(siblingHtml);
										$temp.find('.color-name').text(currentColor);
										
										$currentLoopBlock.append($temp);
									}
								}else {
									var template = $currentLoopBlock.find('template').clone().html(),
										appendHtml = [];

									for (var j2 = 0; j2 < _val.length; j2++) {
										// appendHtml += template.replace(/\*compModelSku\*/g, _val[j2].compModelSku);
										// var str = "*"+_val[j2]+"*";
										var __val = _val[j2],
											htmlLine = template;
										for(var __key in __val) {
											if(template.indexOf(__key) > -1) {
												htmlLine = htmlLine.replace("*"+__key+"*", __val[__key]);
											}
										}
										appendHtml += htmlLine;
									}
									$currentLoopBlock.html(appendHtml);
								}
							}

							// delivery info area delivery-area
							var $deliveries = $html.find('.delivery-area ul');
							for(var i4 = 0; i4 < $deliveries.length; i4++) {
								var markup = $deliveries.eq(0).html();
								if($.trim(markup) == '') {
									$deliveries.eq(0).remove();
								}
							}
							//PJTUSPDPUX-1 START
							// set add to compare button
							if(getCookie(compareCookie.name) != undefined) {
								// console.log(getCookie(compareCookie.name), getCookie(compareCookie.name).indexOf(p.modelId))
								if(p.modelId && getCookie(compareCookie.name).indexOf(p.modelId) != -1) {
									// If compare cookie has this product
									$html.find('.js-compare').addClass('added').prop("checked",true);
								} else {
									$html.find('.js-compare').removeClass('added').prop("checked",false);
								}
							} else {
								$html.find('.js-compare').removeClass('added').prop("checked",false);
							}
							//PJTUSPDPUX-1 END
							// console.log($html.filter(''));
							$(_this.el).find('.mobile-top-info').html(xssfilter($html.filter('.mobile-top-info').html(), true));
							$(_this.el).find('.mobile-bottom-info').html(xssfilter($html.filter('.mobile-bottom-info').html(), true));
							$(_this.el).find('.desktop-info').html(xssfilter($html.filter('.desktop-info').html(), true));

							// change gallery image (modelId, baseProductimage, baseProductAlttext, galleryImgList)
							var galleryList;
							if(p.videos) {
								galleryList = p.videos.concat(p.galleryImages);
							}else {
								galleryList = p.galleryImages;
							}
							
							// change right main visual area change
							_this.changeSubModelImage(id, p.galleryImages[0].largeImageAddr, p.imageAltText, galleryList);

							searchInit(); // common.js
							scrollDesign(); // mCustomScrollbar.js
							runChosen(); // chosen.js
							if(typeof runEcorebates !== "undefined") { // ecorebates
								if($.isFunction(runEcorebates)) runEcorebates();
							}

							// adobe
							if(p.modelName != null && p.modelName != "undefined") {
								$(_this.el).closest('.C0009').attr('data-adobe-modelname', p.modelName);
							} else {
								$(_this.el).closest('.C0009').attr('data-adobe-modelname', '');
							}
							if(p.salesModelCode != null && p.salesModelCode != "undefined") {
								$(_this.el).closest('.C0009').attr('data-adobe-salesmodelcode', p.salesModelCode);
							} else {
								$(_this.el).closest('.C0009').attr('data-adobe-salesmodelcode', '');
							}

							// main visual image thumbnail activate
							$(_this.els.base.desktop.target.querySelectorAll(".thumbnail")[0]).addClass("active");
						}
					}, 'get');
					
					var $stickyBar = $('.C0011');
					if($stickyBar.get(0)) {
						// change C0011 product info
						$stickyBar.trigger('changeSubModel', [p]);
					}
				}
			});
		},
		changeSubModelImage: function(id, basicImg, basicAlt, imgList){
			var _this = this,
				_els = _this.els;
				// basicImg = info.group.subModelInfo[id].basicImg,
				// imgList = info.group.subModelInfo[id].galleryImg;
			_els.base.detail.target.setAttribute('src', basicImg);
			_els.base.detail.target.setAttribute('alt', basicAlt);
			_els.base.detail.target.setAttribute('data-src', basicImg);

			// change desktop thumbnails
			_this.create.desktopThumbnail(imgList);

			// reset slicks
			summaryGallery.m.el.removeAttribute('data-initialized');
			modal.el.gallery.removeAttribute('data-initialized');
			var slicks = [
				$(_els.base.mobile.target),
				$(_els.modal.thumbnails.target),
				$(_els.modal.detail.target)
			];
			for (var i = 0; i < slicks.length; i++) {
				var _curSlick = slicks[i];
				if(_curSlick.is('.slick-initialized')) {
					_curSlick.slick('unslick');
				}
			}

			$(_els.base.mobile.target).find('.thumbnail, .video').remove();
			$(_els.modal.thumbnails.target).find('.image, .video').remove();
			$(_els.modal.detail.target).find('.image, .video').remove();

			var mobileThumbnail = _this.create.elements(imgList, _els.base.mobile, "largeImageAddr"),
				modalThumbnail = _this.create.elements(imgList, _els.modal.thumbnails, "smallImageAddr"),
				modalDetail = _this.create.elements(imgList, _els.modal.detail);

			$(_els.base.mobile.target).append(mobileThumbnail);
			$(_els.modal.thumbnails.target).find('ul').append(modalThumbnail);
			$(_els.modal.detail.target).append(modalDetail);

			if(modal.el.gallery.getAttribute('data-zoom-initialized')) {
				modal.el.gallery.removeAttribute('data-zoom-initialized');
			}

			summaryGallery.d.setThumbnailsIdx();
			summaryGallery.init();

		},
		addEvent: function(){
			var _this = this;

			// general type Sibling Change fnc
			$(_this.el).on({
				click: function(e){
					var _anchor = e.currentTarget,
						id = _anchor.getAttribute('data-model-id'),
						subId = _anchor.getAttribute('data-sub-model-id');

					if(subId){
						e.preventDefault();
						_this.changeSubModelInfo(id, subId);
					}
				}
			}, '.sibling-area a');

			// select type Sibling Change fnc
			// "CARRIER", "CAPACITY", "COOLING CAPACITY"
			$(_this.el).on({
				change: function(e){
					var id = e.currentTarget.getAttribute('data-model-id'),
						currentIdx = e.currentTarget.selectedIndex,
						currentOption = e.currentTarget.options[currentIdx],
						curreontType = currentOption.getAttribute('data-type');

					var sub = currentOption.value;

					if(curreontType && curreontType.toUpperCase() == 'SELF') {
						_this.changeSubModelInfo(id, sub);
					}else if(curreontType && curreontType.toUpperCase() == 'NEW'){
						location.href = sub;
					}
				}
			}, '.sibling-area select');

			$(_this.el).on({
				change: function(e){
					var cur = e.currentTarget,
						$block = $(cur).closest('form').find('.field-block');
					if(cur.value.length == 0) {
						$block.removeClass('error pass fail');
					}
					$block.find('.search-common-input').val(cur.value);
				}
			}, '.search-common .search-common-input');
			$(_this.el).on({
				click: function(e){
					e.preventDefault();
					var cur = e.currentTarget,
						$input = $(cur).closest('form').find('.search-common-input'),
						model = $(cur).find('.model-name').text();
					$(cur).closest('form').find('.search-layer').removeClass('active');
					$input.val(model).focus();

					$(cur).closest('form').trigger('submit');
				}
			}, '.search-common a.anchor');
			$(_this.el).on({
				click: function(e){
					e.preventDefault();
					var cur = e.currentTarget;
					var $input = $(cur).closest('form').find('.search-common-input');

					$input.val('').focus().trigger('change');
				}
			}, '.search-common input.reset');
			$(_this.el).on({
				submit: function(e){
					e.preventDefault();

					var _del = $(e.currentTarget).closest('form'),
						$block = $(_del).find('.field-block'),
						url = $(_del).attr('action'),
						param = xssfilter($(_del).serialize());

					$(_del).find('.search-layer').removeClass('active');

					if($block.find('.search-common-input').val() != '') {
						ajax.call(url, param, 'json', function(data){
							if(data.results == true) {
								// success
								$block.addClass('pass').removeClass('error fail');
								$block.find('.valid').show().siblings().hide();
							}else {
								// fail
								$block.removeClass('pass error').addClass('fail');
								$block.find('.invalid').show().siblings().hide();
							}
						});
					}else {
						$block.removeClass('pass fail').addClass('error');
						$block.find('.required').show().siblings().hide();
					}
				}
			}, '.search-common');
			
			/* PJTWAUS-1 : 20200116 add */
			$(_this.el).on({
				keyup : function(e){
					if($('.search-result-list').is(':visible')){
						$(this).attr('aria-expanded', true);
					}else{
						$(this).attr('aria-expanded', false);
					}
				}
			}, '.search-common .search-common-input');
			/*// PJTWAUS-1 : 20200116 add */
		}
	};

	// DC-1815 Start
	var keyFeatures = {
		iconEl: '#keyFeaturesToggle',
		toggalableEls: document.querySelectorAll('.feature-list li:not(:nth-of-type(1)):not(:nth-of-type(2))'),
		productSpecLink: document.querySelectorAll('.pdp-bottom-info .key-list a'),
		isExpanded: false,
		addEvent: function() {
			var _this = this;
			var $toggalableFeatures = $(_this.toggalableEls);
			var $productSpecLink = $(_this.productSpecLink);

			$productSpecLink.on('click', function(e) {
				$('.C0011 .tab-menu a[href="#pdp_spec"]').click();
				var label = 'Product Specs';
				var action = 'key features';
				var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
				dataLayer.push({
					"event": "lgEvent",
					"category": templateName,
					"action": action,
					"label": label,
					"businessUnit": bu,
					"componentID": "C0009"
				});
			});
			
			$(document).on('click', _this.iconEl, function() {
				var iconTransformStyle;
				if (!_this.isExpanded) {
					iconTransformStyle = 'none';
					_this.isExpanded = true;
					$(this).attr('aria-expanded', true);
					$(this).find('.sr-only').text('Hide Key Features');
				} else {
					iconTransformStyle = 'rotate(45deg)';
					_this.isExpanded = false;
					$(this).attr('aria-expanded', false);
					$(this).find('.sr-only').text('Expand Key Features');
				}

				$(this).css('transform', iconTransformStyle);
				$toggalableFeatures.toggle();
				$productSpecLink.toggle();

				var label = !!_this.isExpanded ? 'expand' : 'close';
				var action = 'key features';
				var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
				dataLayer.push({
					"event": "lgEvent",
					"category": templateName,
					"action": action,
					"label": label,
					"businessUnit": bu,
					"componentID": "C0009"
				});
			});
		},
		handleWA: function() {
			var $toggleButton = $('.pdp-bottom-info p > a');
			var $waTextEl = $('<span class="sr-only">Expand Key Features</span>');
			$toggleButton.append($waTextEl);
		},
		init: function() {
			var _this = this;
			_this.handleWA();
			_this.addEvent();
		}
	}
	// DC-1815 End

	// DC-1971 Start
	var zipCodeToggle = {
		iconEl: '#zipCodeToggle, #zipCodeToggleMobile',
		zipCodeToggableEls: document.querySelectorAll('.desktop-info .chkStBox, #error_Pincode'),
		mobileZipCodeToggableEls: document.querySelectorAll('.mobile-bottom-info .chkStBox, #mobile_error_Pincode'),
		isExpanded: false,
		isMobileExpanded: false,
		addEvent: function() {
			var _this = this;
			var $toggalable = $(_this.zipCodeToggableEls);
			var $mobileToggalable = $(_this.mobileZipCodeToggableEls);

			$(document).on('click', _this.iconEl, function() {
				var iconTransformStyle;
				var device = 'desktop';

				if ($(this).attr('id') === 'zipCodeToggleMobile') {
					device = 'mobile';
				}

				var newExpandedState;
				
				if (device === 'desktop') {
					if (!_this.isExpanded) {
						iconTransformStyle = 'none';
						_this.isExpanded = true;
						$(this).attr('aria-expanded', true);
					} else {
						iconTransformStyle = 'rotate(45deg)';
						_this.isExpanded = false;
						$(this).attr('aria-expanded', false);
					}
					$(this).css('transform', iconTransformStyle);
					$toggalable.toggle();
					newExpandedState = _this.isExpanded;
				} else {
					if (!_this.isMobileExpanded) {
						iconTransformStyle = 'none';
						_this.isMobileExpanded = true;
						$(this).attr('aria-expanded', true);
					} else {
						iconTransformStyle = 'rotate(45deg)';
						_this.isMobileExpanded = false;
						$(this).attr('aria-expanded', false);
					}
					$(this).css('transform', iconTransformStyle);
					$mobileToggalable.toggle();
					newExpandedState = _this.isMobileExpanded;
				}

				var label = !!newExpandedState ? 'expand' : 'close';
				var action = 'zip code';
				var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
				dataLayer.push({
					"event": "lgEvent",
					"category": templateName,
					"action": action,
					"label": label,
					"businessUnit": bu,
					"componentID": "C0009"
				});
				
			});
		},
		init: function() {
			var _this = this;
			_this.addEvent();
			$(_this.iconEl).click();
		}
	};
	// DC-1971 End

	// DC-21 Handy implementation
	var handyModal = {
		mobileEl: document.querySelector('.wallmount-area.mobile'),
		modalButton: document.querySelectorAll('#handyAdd'),
		modalClose: document.querySelector('#wall-mounting-modal .modal-close'),
		addToCartButton: document.querySelector('#addHandyToCart'),
		dismissButton: document.querySelector('#handyDismiss'),
		mountOptionEls: document.querySelectorAll('.wallmount-area .product-card.pop'),
		handyServicePriceEl: document.querySelector('.wall-mounting-area .product-card .product-price'),
		handyServicePrice: '',
		selectedMount: null,
		isCarouselInitialized: false,
		addEvent: function() {
			var _this = this;
			var $dismissButton = $(_this.dismissButton);
			var $addToCartButton = $(_this.addToCartButton);
			var $carouselContainer = $(_this.mobileEl);
			var $modalButton = $(_this.modalButton);
			var $modalClose = $(_this.modalClose);
			var $handyServicePriceEl = $(_this.handyServicePriceEl);

			if ($handyServicePriceEl) {
				var elPrice = parseFloat($handyServicePriceEl.text().replace('$', ''));
				if (isNaN(elPrice)) {
					elPrice = 'FREE';
				}
				_this.handyServicePrice = elPrice;
			}

			var $mountOptionEls = $(_this.mountOptionEls);
			var $radioButtonLabels = $mountOptionEls.find('label');

			var onRadioEnter = function(event) {
				if (event.keyCode === 13) {
					$(this).parent().find('label').click();
				}
			}

			var onChooseOption = function(event) {
				var $radioInput = $(this).parent().find('input[name="wallmountselect"]');
				var price = parseFloat($(this).parent().find('.product-price').text().replace('$', ''));
				var mountName = $(this).parent().find('.product-name').text();
				var value = $radioInput.val();
				var label = nvl_def(_dl.page_name.sku);

				if ($radioInput.is(':checked')) {
					setTimeout(function() {
						$radioInput.prop('checked', false);
						$dismissButton.show();
						$addToCartButton.hide();
						_this.selectedMount = {
							isServiceOnly: true,
							handyService: _this.handyServicePrice,
						};
					}, 5);
				} else {
					$dismissButton.hide();
					$addToCartButton.show();
					_this.selectedMount = {
						isServiceOnly: false,
						handyService: _this.handyServicePrice,
						sku: value,
						price: price,
						name: mountName,
					};;

					dataLayer.push({
						"event": "lgEvent",
						"category": "pdp",
						"action": "select wall mount",
						"label": label,
						"handySku": value,
					});
				}
			}

			var resetState = function() {
				var $wallMountEl = $('.wall-mounting-area .product-card');
				$wallMountEl.find('.product-name').text('Wall Mounting Service');
				if (isNaN(parseFloat(_this.handyServicePrice))) {
					$wallMountEl.find('.product-price').text('FREE')
				} else {
					$wallMountEl.find('.product-price').text('$' + parseFloat(_this.handyServicePrice).toFixed(2));
				}
				
				$('input[name="wallmountselect"]').prop('checked', false);
				$dismissButton.show();
				$addToCartButton.hide();

				_this.selectedMount = null;
				addToCart.handyWallmountData = null;

				$modalButton.text('ADD');
				$modalButton.attr('data-action', 'add');
			}

			$('#wall-mounting-modal input[name="wallmountselect"]').on('keyup', onRadioEnter);
			$radioButtonLabels.on('click', onChooseOption);

			$modalButton.on('click', function() {
				if ($(this).text() === 'REMOVE') {
					resetState();
				} else {
					if (!$(this).data('mount-included')) {
						$("#wall-mounting-modal").modal("show");
						$('#wall-mounting-modal input[name="wallmountselect"]')[0].focus();
					}
					
					$(this).text('REMOVE');
					$(this).attr('data-action', 'remove');

					_this.selectedMount = {
						isServiceOnly: true,
						handyService: _this.handyServicePrice,
					};

					addToCart.handyWallmountData = _this.selectedMount;

					var label = nvl_def(_dl.page_name.sku);
					dataLayer.push({
						"event": "lgEvent" ,
						"category": "pdp",
						"action": "add handy wall mounting",
						"label": label,
					});
				}

				if (_this.isCarouselInitialized) {
					$carouselContainer.slick('unslick');
				}

				// DC-21: Need to initialize carousel only after modal renders
				setTimeout(function() {
					$carouselContainer.slick({
						infinite:false,
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						dots: true,
						swipeToSlide : true,
						listStyle: true,
						appendDots: $('.choose-mount').find('.dot-box'),
					});
					if (!_this.isCarouselInitialized) {
						_this.isCarouselInitialized = true;
					}
					setTimeout(function() {
						$carouselButtonLabels = $carouselContainer.find('.product-card.pop label');
						$carouselButtonLabels.on('click', onChooseOption);
						$('#wall-mounting-modal .wallmount-area.mobile input[name="wallmountselect"]').on('keyup', onRadioEnter);
						$('#wall-mounting-modal .wallmount-area.mobile input[name="wallmountselect"]')[0].focus();
						$('.wallmount-area.mobile .slick-track, .wallmount-area.mobile .slick-track .product-card').css('width', '308px');
					}, 5);
				}, 250);
			});

			$addToCartButton.on('click', function() {

				addToCart.handyWallmountData = _this.selectedMount;

				// Add price amounts to main price and handy price
				var $wallMountEl = $('.wall-mounting-area .product-card');
				$wallMountEl.find('.product-name').text('Wall Mounting Service w/ a Mount');

				if (isNaN(parseFloat(_this.selectedMount.price + _this.handyServicePrice))) {
					$wallMountEl.find('.product-price').text('FREE + $' + parseFloat(_this.selectedMount.price).toFixed(2));
				} else {
					$wallMountEl.find('.product-price').text('$' + parseFloat(_this.selectedMount.price + _this.handyServicePrice).toFixed(2));
				}
				
				$('#wall-mounting-modal').modal('hide');
			});
		},
		init: function() {
			this.addEvent();
		},
	};

	summary.init();

	modal.init();
	summaryGallery.init();
	keyFeatures.init();
	zipCodeToggle.init();
	handyModal.init();

	// for submodel
	var submodel = $('.C0009').data('default-model');
	if(submodel) {
		$('a[data-sub-model-id="'+submodel+'"]').eq(0).trigger('click');
	}

	// DC-1971 Start
	$('.chkStBox input').on('input', function() {
		$('.pdp-info.desktop-info').find('#error_Pincode').hide();
		$('.pdp-info.mobile-bottom-info').find('#mobile_error_Pincode').hide();
		$(this).removeClass('success');
		$(this).removeClass('invalid');
		$(this).css('color', '#333');
		$(this).css('font-weight', 'normal');
	});
	// DC-1971 End

	var $findADealerButton = $('.pdp-info a[href="#pdp_findadealer"]');
	if ($findADealerButton.length) {
		$findADealerButton.on('click', function() {
			$('.tab-menu a[href="#pdp_findadealer"]').click();
		});
	}

	//DC-116 START
	$('.rating-area').on('click', function(e){
		e.preventDefault();
		
		setTimeout(function() {
			$target = $('#pdp_review');
			$tabMenuList = $(".C0011").find(".tab-menu-belt")
			$linkers = $tabMenuList.find('.linker:not(.wtb-external-link)')
			$tabContainers = $linkers.map(function(){ return $.find($(this).attr('href'))})
			
			$tabContainers.not($target).hide();
			$target.show();	
			$('.C0016').show();

			var menuPos = parseInt($(".C0009").offset().top + $(".C0009").parent().height());
			$('html, body').stop().animate({scrollTop: menuPos}, {duration:500});
			$target.attr('tabindex','0'); 
			$target.focus();

			var selected = $.grep($linkers, function(elem) {return elem.hash === '#pdp_review';})
			$linkers.attr('aria-selected', false);
			$(selected).attr('aria-selected', true);
			$(selected).parent().addClass('active').siblings().removeClass('active');

			//DC-792 Follow up for DC-538 START
			var label = nvl_def(_dl.page_name.sku)
			var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
			if(!bu) bu = nvl_def(_dl.page_name.bu);
			dataLayer.push({
				"event": "lgEvent" ,
				"category": "(T0005C)PDP" ,
				"action": "write a review" ,
				"label": label ,
				"businessUnit": bu ,
				"componentID": "C0009"
				});
			//DC-792 END
		}, 100);
	})

	//PJTUSPDPUX-1 START
	$('.wish').on('click', function(e){
		var wishDataUrl = $('.C0009 .wish-area').attr('wish-data-url');
		var originalModelId = $('.C0009').attr('data-product-id');
		var param = {
			modelId: originalModelId
		};
		ajax.noCacheCall(wishDataUrl, param, 'json', function(data){
			var action='';
			if(data.flag == 'L'){
				$('#wishList').modal('show');
				//DC-538 START
				var label = nvl_def(_dl.page_name.sku)
				var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
				if(!bu) bu = nvl_def(_dl.page_name.bu);
				dataLayer.push({
					"event": "lgEvent" ,
					"category": 'sign in to create your wishlist pop up',
					"action": 'add to wishlist' ,
					"label": label ,
					"businessUnit": bu ,
					"componentID": "C0009"
					});
				//DC-538 END
			}else{
				var returnMsg;
				$('.wish').toggleClass('on');
				if($('.wish').hasClass('on')){
					//add
					$('.view-wish').css('display', 'inline-block');
					action = 'add to wishlist';
				} else{
					//remove
					$('.view-wish').css('display', 'none');
					action = 'remove from wishlist';
				}
				var label = nvl_def(_dl.page_name.sku)
				var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
				if(!bu) bu = nvl_def(_dl.page_name.bu);
				dataLayer.push({
					"event": "lgEvent" ,
					"category": templateName ,
					"action": action ,
					"label": label ,
					"businessUnit": bu ,
					"componentID": "C0009"
					});
			}
		});
	})
	

	if($('.C0009 .wish').length > 0){ 
		var wishPreUrl = $('.C0009 .wish-area').attr('wish-pre-url');
		var originalModelId = $('.C0009').attr('data-product-id');
		var param = {
			modelId: originalModelId
		};
		ajax.noCacheCall(wishPreUrl, param, 'json', function(data){
			if(data.flag == 'Y'){
				$('.wish').toggleClass('on');
				if($('.wish').hasClass('on')){
					$('.view-wish').show();
				} else{
					$('.view-wish').hide();
				}
			}
		});
	}
	
	$('.modal-body .wish-list .btn-area .btn-primary').click(function(){
		var label = nvl_def(_dl.page_name.sku)
		var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
		if(!bu) bu = nvl_def(_dl.page_name.bu);
		dataLayer.push({
			"event": "lgEvent" ,
			"category": 'sign in to create your wishlist pop up',
			"action": "continue to sign in", //DC-538 
			"label": label ,
			"businessUnit": bu ,
			"componentID": "C0009"
			});
		location.href = '/us/mylg/login';
	});

	//DC-538 START
	$('.modal-body .wish-list .btn-area .btn-outline-secondary').click(function(){
		var label = nvl_def(_dl.page_name.sku)
		var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
		if(!bu) bu = nvl_def(_dl.page_name.bu);
		var componentId = nvl_def($(this).closest('.component').attr('class')).split(' ')[1];
		dataLayer.push({
			"event": "lgEvent" ,
			"category": 'sign in to create your wishlist pop up' ,
			"action": "no thanks, not now" ,
			"label": label ,
			"businessUnit": bu ,
			"componentID": "C0009"
			});
	});
	//DC-538 END
	
	$('.wish-area .view-wish').click(function(){
		var label = nvl_def(_dl.page_name.sku)
		var bu = nvl_def($(this).closest('.ga-model-info').data('bu-name')).toLowerCase();
		if(!bu) bu = nvl_def(_dl.page_name.bu);
		dataLayer.push({
			"event": "lgEvent" ,
			"category": templateName ,
			"action": "view wishlist" ,
			"label": label ,
			"businessUnit": bu ,
			"componentID": "C0009"
			});
	});
	
	//PJTUSPDPUX-1 END

	//DC-905 Start
	if($('.C0009 .subscription-disclaimer').length > 0 || $('.C0009 .subscription-area').length > 0){
		var imageUrl = window.location.origin + '/lg5-common/images/common/icons/footnote-marker.png';
		$('.C0009 .subscription-disclaimer .lazyloaded').attr('src', imageUrl);
		$('.C0009 .subscription-disclaimer .lazyloaded').attr('data-src', imageUrl);
		$('.C0009 .subscription-area .lazyloaded').attr('src', imageUrl);
		$('.C0009 .subscription-area .lazyloaded').attr('data-src', imageUrl);
	}
	//DC-905 End

	// DC-1861 Start
	$('.modal.fade').on('shown.bs.modal', function () {
		$(this).siblings().attr('aria-hidden', true);
	});

	$('.modal.fade').on('hidden.bs.modal', function () {
		$(this).siblings().removeAttr('aria-hidden');
	});

	if ($('header.b2b').length) {
		$('.pdp-visual-image.default a').removeAttr('role');
	}
	// DC-1861 End

	// DC-3145 Start

	// WA modifications for klarna info link
	var $klarnaImg = $('.C0009 .vector-klarna');
	if ($klarnaImg.length > 1) {
		var $klarnaLink = $klarnaImg.parent();
		var $klarnaLinkText = 'Click here for more info. (opens in a new window)';
		var $klarnaLinkTextEl = $('<span class="visually-hidden">' + $klarnaLinkText + '</span>');
		$klarnaLink.attr('title', $klarnaLinkText);
		$klarnaLink.prepend($klarnaLinkTextEl);
	}
	// DC-3145 End
});

/*
var callSubModel = function(modelId){
	$('a[data-sub-model-id="'+modelId+'"]').eq(0).trigger('click');
};
*/

//DC-1457 Start
	var selectedItemsElement = document.getElementById("user-selected-items");

    function addItem(btElement){

        var selectedElement = document.getElementsByClassName("product-card")[(btElement.value.charAt(( btElement.value.length )- 1) -1)];
        var selectedItem = document.getElementsByClassName("product-name")[0].innerText;
        var selectedItemPrice = document.getElementsByClassName("product-price")[0].innerText;

        var tempElement = document.createElement("li");

        tempElement.innerHTML = "<div class='selecteditem'> "+selectedItem+"</div> <div class='selecteditemp'>"+selectedItemPrice+" </div>";

        selectedItemsElement.appendChild(tempElement);
    }

    function removeItem(btElement){

        var selectedElement = document.getElementsByClassName("product-card")[(btElement.value.charAt(( btElement.value.length )- 1) -1)];

        var selectedItem = document.getElementsByClassName("product-name")[0].innerText;
        var selectedItemPrice = document.getElementsByClassName("product-price")[0].innerText;

        var tempElement = document.createElement("li");

        tempElement.innerHTML = "<div class='selecteditem'> "+selectedItem+"</div> <div class='selecteditemp'>"+selectedItemPrice+" </div>";

        var selected = selectedItemsElement.childNodes;


        //remove all from the list
        for(var i=selected.length -1; i>=0 ; i--){
            selectedItemsElement.removeChild(selectedItemsElement.childNodes[i]);
        }
    }

    function radioadd() {
        var radios = document.getElementsByName("wallmountselect");


        for (var i = 0; i < radios.length; i++) {       
            if (radios[i].checked) {

                var selectedItem = document.getElementsByClassName("product-name")[i+1].innerText;
                var selectedItemPrice = document.getElementsByClassName("product-price")[i+1].innerText;

                //add to the cart
                var tempElement = document.createElement("li");
                tempElement.innerHTML = "<div class='selecteditem'> "+selectedItem+"</div> <div class='selecteditemp'>"+selectedItemPrice+" </div>";
                selectedItemsElement.appendChild(tempElement);
            }
        }   

        $("#wall-mounting-modal").modal("hide"); //modal open
    }
	//DC-1457 End
